import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { SourceBoardV2 } from '../../utils/types';
import { toFormatDate } from '../../utils/date';
import { MAINTENANCE, SLUDGE_EMPTYING } from '../../utils/rikutec';
import CardItemBoards from '../UI/DataGridCard/CardItemBoards';
import LastNoteField from './LastNoteField';
import InstallationCardActions, { InstallationCardForms } from './InstallationCardActions';
import InstallationFormsPanel from './InstallationFormsPanel';

/** An empty field keeps its place, so every card reads the same whatever has been filled in. */
const orNA = (value: string | number | null | undefined) => value || 'N/A';
const dateOrNA = (value: string | null | undefined) => (value ? toFormatDate(value) : 'N/A');

/**
 * A line of the v2 board: the v1 card with the fields of the traceability process. "Historique"
 * opens the history panel, as clicking the card does; "Formulaires" unfolds every form group.
 */
const BoardV2Card = ({ record }: { record: SourceBoardV2 }) => {
    const t = useTranslate();
    const [expanded, setExpanded] = useState(false);

    const details = [
        { label: t('app.objects.info.created'), value: dateOrNA(record.creationDate) },
        { label: t('app.ancsV2.columns.model'), value: orNA(record.model) },
        { label: t('app.ancsV2.columns.processingCapacity'), value: orNA(record.processingCapacity) },
        { label: t('app.ancsV2.columns.clientFullName'), value: orNA(record.clientFullName) },
        { label: t('app.ancsV2.columns.installerCompany'), value: orNA(record.installerCompany) },
        { label: t('app.ancsV2.columns.installationCity'), value: orNA(record.installationCity) },
        { label: t('app.ancsV2.columns.poseDate'), value: dateOrNA(record.poseDate) },
        {
            label: t('app.ancsV2.columns.lastMaintenance'),
            value: (
                <LastNoteField
                    date={record.productLastMaintenanceDate}
                    note={record.productLastMaintenanceData}
                    tag={MAINTENANCE}
                />
            ),
        },
        {
            label: t('app.ancsV2.columns.lastEmptying'),
            value: (
                <LastNoteField
                    date={record.productLastEmptyingDate}
                    note={record.productLastEmptyingData}
                    tag={SLUDGE_EMPTYING}
                />
            ),
        },
        {
            label: t('app.ancsV2.groups.signatures'),
            value: `${[record.hasOwnerSignature, record.hasInstallerSignature].filter(Boolean).length}/2`,
        },
    ];

    return (
        <CardItemBoards
            record={record}
            details={details}
            headerAction={
                <InstallationCardActions
                    record={record}
                    formsOpen={expanded}
                    onToggleForms={() => setExpanded(!expanded)}
                />
            }
        >
            <InstallationCardForms open={expanded}>
                <InstallationFormsPanel record={record} />
            </InstallationCardForms>
        </CardItemBoards>
    );
};

export default BoardV2Card;
